import NewTabsController from './new_tabs_controller';

export default class extends NewTabsController {
  connect() {
    document.addEventListener('new-tab:change', this.updateTickets);
  }
  disconnect() {
    document.removeEventListener('new-tab:change', this.updateTickets);
  }

  updateTickets = async (e) => {
    const categoryId = e?.detail.activeTab.childNodes[0].dataset.tabId;

    try {
      await this.updateComponent({
        componentUrl: '/ticket_order/tickets/tickets_for_category_component',
        componentSelector: `.tickets-container`,
        body: {
          category_id: categoryId,
          event_slug: this.element.dataset.eventSlug,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
}
